import { render, staticRenderFns } from "./custom-menu.vue?vue&type=template&id=2525f502&scoped=true&"
import script from "./custom-menu.vue?vue&type=script&lang=js&"
export * from "./custom-menu.vue?vue&type=script&lang=js&"
import style0 from "./custom-menu.vue?vue&type=style&index=0&id=2525f502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2525f502",
  null
  
)

export default component.exports